import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  Select,
  Spin,
  Icon,
  message,
  Drawer,
  Input,
  Radio
} from 'antd';

import { get, post, put } from '../../utils/httpRequests';
import { APIs } from '../../utils/apis';

const { Option } = Select;

const columns = [
  {
    title: 'Display Name',
    key: 'display_name',
    width: 10
  },
  {
    title: 'Frequency',
    key: 'frequency',
    width: 10
  },
  {
    title: 'Usecase',
    key: 'use_case',
    width: 15
  },
  {
    title: 'Report Name',
    key: 'report_name',
    width: 10
  },
  {
    title: 'Level',
    key: 'level',
    width: 8
  },
  {
    title: 'Tags',
    key: 'tags',
    width: 10
  },
  {
    title: 'Number of Customers',
    key: 'number_of_customers',
    width: 10
  },
  {
    title: 'Columns',
    key: 'columns',
    width: 10
  },
  {
    title: 'HTML Support',
    key: 'html_support',
    width: 8
  },
  {
    title: 'Actions',
    key: 'report_active',
    width: 18
  }
];

const levelOptions = [
  { value: 'L1', label: 'L1' },
  { value: 'L2', label: 'L2' },
  { value: 'L3', label: 'L3' }
];

const reportTags = [
  {
    value: 'RTO Journey, Forward Shipment Journey: Stuck, Ageing & SLA breach',
    label: 'RTO Journey, Forward Shipment Journey: Stuck, Ageing & SLA breach'
  },
  {
    value: 'Forward Shipment Journey: Stuck, Ageing & SLA breach',
    label: 'Forward Shipment Journey: Stuck, Ageing & SLA breach'
  },
  { value: 'NDR/RTO Reduction', label: 'NDR/RTO Reduction' },
  { value: 'Returns & Exchange', label: 'Returns & Exchange' },
  {
    value: 'Forward Shipment Journey: All Orders',
    label: 'Forward Shipment Journey: All Orders'
  },
  {
    value: 'RTO Journey, NDR/RTO Reduction',
    label: 'RTO Journey, NDR/RTO Reduction'
  },
  { value: 'RTO Journey', label: 'RTO Journey' },
  {
    value: 'Forward Shipment Journey: All Orders, RTO Journey',
    label: 'Forward Shipment Journey: All Orders, RTO Journey'
  }
];
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const ReportMetadata = () => {
  const [state, setState] = useState({
    reports: [],
    count: null,
    isFetching: true,
    reportName: 'all',
    options: [],
    download: {
      show: false,
      emails: [],
      enterpriseId: null,
      reportName: ''
    },
    page: 1,
    enterprises: [],
    level: 'all',
    tags: 'all',
    editReport: {
      show: false,
      id: null,
      reportName: '',
      displayName: '',
      frequency: '',
      use_case: '',
      level: '',
      tags: '',
      numberOfCustomers: null,
      columns: '',
      htmlSupport: false,
      isActive: false
    }
  });

  const fetchData = () => {
    let url = `${APIs.NEW_REPORT_METADATA}&page=${state.page}&size=${20}&`;
    if (state.reportName !== 'all') {
      url += `report_name=${state.reportName}`;
    }
    if (state.level !== 'all') {
      url += `&level=${state.level}`;
    }
    if (state.tags !== 'all') {
      url += `&tags=${encodeURIComponent(state.tags)}`;
    }
    get({
      url
    }).then(res => {
      if (res?.data?.meta?.status === 200) {
        if (state.page > 1) {
          state.reports = state.reports.concat(res?.data?.result?.report ?? []);
        } else {
          state.reports = res?.data?.result?.report ?? [];
        }
        state.count = res?.data?.result?.count;
        state.options = [
          ...new Set([
            ...state.options,
            ...res?.data?.result?.report.map(report => report.report_name)
          ])
        ];
      }
      setState({ ...state, isFetching: false });
    });
  };

  const fetchEnterprises = () => {
    get({
      url: APIs.ACTIVE_REPORTS.META_DATA + 'filters=enterprise'
    }).then(res => {
      if (res?.data?.meta?.status === 200) {
        state.enterprises = res?.data?.result?.enterprises ?? [];
      }
      setState({ ...state, isFetching: false });
    });
  };

  const downloadReport = () => {
    const data = {
      enterprise_id: state.download.enterpriseId,
      report_name: state.download.reportName,
      email_to_list: state.download.emails
    };

    post({
      url: APIs.REPORT_DOWNLOAD,
      data
    }).then(res => {
      if (res?.data?.meta?.status_code === 200) {
        message.success(
          res?.data?.meta?.message ?? 'Please check your email in a few minutes'
        );
      } else {
        message.error(
          res?.data?.meta?.message ??
            'There is a download report API error. Please contact frontend team'
        );
      }
      state.download = {
        show: false,
        emails: [],
        enterpriseId: null,
        reportName: ''
      };
      setState({ ...state });
    });
  };

  const editReport = () => {
    const {
      reportName,
      displayName,
      frequency,
      use_case,
      level,
      tags,
      numberOfCustomers,
      columns,
      htmlSupport,
      isActive,
      id
    } = state.editReport || {};

    let data = {
      report_name: reportName,
      display_name: displayName,
      frequency: frequency,
      use_case: use_case,
      level: level,
      tags: tags,
      number_of_customers: numberOfCustomers,
      columns: columns,
      html_support: htmlSupport,
      is_active: isActive
    };

    if (id) {
      data = {
        ...data,
        id: id
      };
    }

    const request = id ? put : post;

    request({
      url: `${APIs.NEW_REPORT_METADATA}`,
      data
    }).then(res => {
      if (res?.data?.meta?.status === 200) {
        message.success(
          res?.data?.meta?.message ?? 'Report meta data updated successfully'
        );
      } else {
        message.error(
          res?.data?.meta?.message ??
            'Update failed. Please contact frontend team'
        );
      }
      state.editReport = {
        id: null,
        reportName: '',
        displayName: '',
        frequency: '',
        use_case: '',
        level: '',
        tags: '',
        numberOfCustomers: null,
        columns: '',
        htmlSupport: false,
        isActive: false,
        show: false
      };

      state.isFetching = true;
      setState({ ...state });
      fetchData();
    });
  };

  const toggleDownload = (show, reportName) => {
    state.download.show = show;
    state.download.reportName = reportName;
    setState({ ...state });
  };

  const toggleEdit = (show, report) => {
    const {
      id,
      report_name = '',
      display_name = '',
      frequency = '',
      use_case,
      level,
      tags,
      number_of_customers,
      columns,
      html_support,
      is_active
    } = report || {};

    state.editReport = {
      id: id,
      reportName: show ? report_name : '',
      displayName: show ? display_name : '',
      frequency: show ? frequency : '',
      use_case: show ? use_case : '',
      level: show ? level : '',
      tags: show ? tags : '',
      numberOfCustomers: show ? number_of_customers : '',
      columns: show ? columns : '',
      htmlSupport: show ? html_support ?? false : false,
      isActive: show ? is_active ?? false : false,
      show: show
    };
    setState({ ...state });
  };

  const onChange = e => {
    const { name, value } = e.target;
    state.editReport[name] = value;
    setState({ ...state });
  };

  const onEmailChange = value => {
    state.download.emails = value;
    setState({ ...state });
  };

  const onSelectChange = value => {
    state.download.enterpriseId = value;
    setState({ ...state });
  };

  const pagination = () => {
    state.page = state.page + 1;
    setState({ ...state });
    fetchData();
  };

  useEffect(() => {
    fetchData();
    fetchEnterprises();
  }, []);

  const reportEditAdd = state.editReport.reportName ? 'Edit' : 'Add';

  return (
    <div>
      <Row className="margin-bottom-10 view-header">
        <Col span={19} className="margin-bottom-10">
          <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Select enterprise"
            optionFilterProp="children"
            value={state.reportName}
            onChange={value =>
              setState({ ...state, reportName: value, page: 1 })
            }
            allowClear={true}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <option value="all">All reports</option>
            {state.options.map(reportName => (
              <Option key={reportName} value={reportName}>
                {reportName}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={5} className="text-right">
          <Button
            className="ant-btn ant-btn-primary margin-right-10"
            onClick={() => toggleEdit(true)}
          >
            Add New Report
          </Button>
          <Button
            className="ant-btn ant-btn-primary"
            disabled={!state.reportName || !state.tags || !state.level}
            onClick={fetchData}
          >
            Submit
          </Button>
        </Col>
        <Col span={6}>
          <Select
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Level"
            optionFilterProp="children"
            value={state.level}
            onChange={value => setState({ ...state, level: value, page: 1 })}
            allowClear={true}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <option value="all">All Levels</option>
            {levelOptions.map(item => (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={13}>
          <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Select Tags"
            optionFilterProp="children"
            value={state.tags}
            onChange={value => setState({ ...state, tags: value, page: 1 })}
            allowClear={true}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <option value="all">All tags</option>
            {reportTags.map(item => (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={24} className="margin-bottom-10">
          {state.isFetching ? (
            <Spin indicator={antIcon} />
          ) : (
            <>
              {state.reports.length <= 0 ? (
                <div>&nbsp; No Data</div>
              ) : (
                <>
                  <table
                    className={`ant-table ant-table-small width-100pt`}
                    style={{ tableLayout: 'fixed' }}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                            {/* <Icon type="sort-ascending" /> */}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {state.reports.map((report, i) => (
                        <tr key={i}>
                          <td className="padding-8">{report.display_name}</td>
                          <td className="padding-8">{report.frequency}</td>
                          <td className="padding-8">{report.use_case}</td>
                          <td className="padding-8">{report.report_name}</td>
                          <td className="padding-8">{report.level}</td>
                          <td
                            className="padding-8"
                            style={{ maxWidth: '400px' }}
                          >
                            {report.tags}
                          </td>
                          <td
                            className="padding-8"
                            style={{ maxWidth: '400px' }}
                          >
                            {report?.number_of_customers}
                          </td>
                          <td className="padding-8">{report.columns}</td>
                          <td className="padding-8">
                            {report.html_support ? 'Yes' : 'No'}
                          </td>
                          <td className="padding-8">
                            <Button
                              className="ant-btn ant-btn-primary margin-right-10"
                              onClick={() =>
                                toggleDownload(true, report.report_name)
                              }
                            >
                              Download
                            </Button>
                            <Button
                              onClick={() => toggleEdit(true, report)}
                              type="ghost"
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </>
          )}
        </Col>
        {!state.isFetching && state.count > state.reports?.length ? (
          <Col span={24} className="text-center">
            <Button
              type="primary"
              onClick={pagination}
              loading={state.reports.isPaginationFetching}
              disabled={state.reports.isPaginationFetching}
            >
              Load More
            </Button>
          </Col>
        ) : null}
      </Row>
      {state.download.show && (
        <Drawer
          title={`Download Report - ${state.download.reportName}`}
          placement="right"
          onClose={() => toggleDownload(false)}
          visible={state.download.show}
          width={'50%'}
        >
          <>
            <span>Select Enterprise</span>
            <Select
              showSearch
              placeholder="Select Enterprise"
              value={state.download.enterpriseId}
              mode="single"
              style={{ width: '100%' }}
              onChange={value => onSelectChange(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              allowClear
              className="margin-bottom-20"
            >
              {state.enterprises?.map((enterprise, i) => (
                <Option key={i} value={enterprise.id}>
                  {enterprise.name}
                </Option>
              ))}
            </Select>
            <span>Enter emails (Press enter after each entry)</span>
            <Select
              mode="tags"
              style={{ width: '100%' }}
              onChange={onEmailChange}
              tokenSeparators={[',']}
              className="margin-bottom-20"
            >
              {state.download.emails.map(email => (
                <Option key={email}>{email}</Option>
              ))}
            </Select>
            <div className="text-right">
              <Button
                className="ant-btn ant-btn-primary"
                onClick={downloadReport}
                disabled={
                  !state.download.enterpriseId ||
                  !state.download.reportName ||
                  state.download.emails.length === 0
                }
              >
                Download
              </Button>
            </div>
          </>
        </Drawer>
      )}
      {state.editReport.show && (
        <Drawer
          title={`${
            state.editReport.reportName
              ? `Edit Report - ${state.editReport.reportName}`
              : 'Add New Report'
          }`}
          placement="right"
          onClose={() => toggleEdit(false)}
          visible={state.editReport.show}
          width={'50%'}
        >
          <>
            <span>{reportEditAdd} Report Name</span>
            <Input
              name="reportName"
              value={state.editReport.reportName}
              placeholder="Add report name"
              onChange={onChange}
              className="margin-bottom-10"
            />
            <span>{reportEditAdd} Display Name</span>
            <Input
              name="displayName"
              value={state.editReport.displayName}
              placeholder="Add report meta data"
              onChange={onChange}
              className="margin-bottom-10"
            />
            <span>{reportEditAdd} Frequency</span>
            <Input
              name="frequency"
              value={state.editReport.frequency}
              placeholder="Add frequency"
              onChange={onChange}
              className="margin-bottom-10"
            />
            <span>{reportEditAdd} Usecase</span>
            <Input
              name="use_case"
              value={state.editReport.use_case}
              placeholder="Add usecase"
              onChange={onChange}
              className="margin-bottom-10"
            />
            <span>{reportEditAdd} Level</span>
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Select Level"
              optionFilterProp="children"
              className="margin-bottom-10"
              value={state.editReport.level}
              onChange={value =>
                setState({
                  ...state,
                  editReport: { ...state.editReport, level: value }
                })
              }
              allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {levelOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
            <span>{reportEditAdd} Tags</span>
            <Select
              showSearch
              name="tags"
              style={{ width: '100%' }}
              placeholder="Select Tag"
              optionFilterProp="children"
              value={state.editReport.tags}
              onChange={value =>
                setState({
                  ...state,
                  editReport: { ...state.editReport, tags: value }
                })
              }
              allowClear={true}
              className="margin-bottom-10"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {reportTags.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
            <span>{reportEditAdd} Number of Customers</span>
            <Input
              name="numberOfCustomers"
              value={state.editReport.numberOfCustomers}
              placeholder="Add Number of Customers"
              type="number"
              onChange={onChange}
              className="margin-bottom-10"
            />
            <span>{reportEditAdd} Columns</span>
            <Input
              name="columns"
              value={state.editReport.columns}
              placeholder="Add Columns"
              onChange={onChange}
              className="margin-bottom-20"
            />
            <div>
              <span className="margin-right-10">Report supports HTML?</span>
              <Radio.Group
                name="htmlSupport"
                onChange={onChange}
                value={state.editReport.htmlSupport}
                className="margin-bottom-10"
              >
                <Radio value={true}>True</Radio>
                <Radio value={false}>False</Radio>
              </Radio.Group>
            </div>
            <span className="margin-right-10">Report is active?</span>
            <Radio.Group
              name="isActive"
              onChange={onChange}
              value={state.editReport.isActive}
              className="margin-bottom-10"
            >
              <Radio value={true}>True</Radio>
              <Radio value={false}>False</Radio>
            </Radio.Group>
            <div className="text-right">
              <Button
                className="ant-btn ant-btn-primary"
                onClick={editReport}
                disabled={
                  !state.editReport.reportName ||
                  !state.editReport.displayName ||
                  !state.editReport.frequency
                }
              >
                Submit
              </Button>
            </div>
          </>
        </Drawer>
      )}
    </div>
  );
};

export default ReportMetadata;
